<template>
<div id="secure">

    <TopMenu />
    <section class="main-content columns is-fullheight">
        <div class="container column is-12">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card">
                    <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                        <ul>
                            <li><a v-on:click="goDashboard()">Group Dashboard</a></li>
                            <li class="is-active"><a v-on:click="goGroupDashboardSingle()">{{ groupName }}</a></li>
                            <li class="is-active" v-if="viewStudentAttendance == 1"><a href="#" aria-current="page">Attended Students for {{ todayDateDisplay}} <span v-if="viewStudentAttendanceStatus == 2" style="padding-left: 5px;">(Late)</span></a></li>
                            <li class="is-active" v-if="viewStudentAttendance == 2"><a href="#" aria-current="page">Absent Students for {{ todayDateDisplay }}</a></li>
                            <li class="is-active" v-if="viewStudentAttendance == 3"><a href="#" aria-current="page">Attendance list for {{ todayDateDisplay }}</a></li>
                        </ul>
                    </nav>
                </div><br/>
                    
                <div class="columns">
                    <div class="column one-half">
                        <div class="card">
                            <loading :active.sync="isLoading1" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Student List 
                                <datepicker @closed="getAttendance(viewStudentAttendance,viewStudentAttendanceStatus,selectedDate,1)"  v-model="selectedDate" wrapper-class="datepicker" placeholder="Select Date" :value="todayDate" :class="$style.datepicker" calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker></p>
                                
                                <div style="padding: 10px;">
                                    <a class="button is-info is-small" style="margin-left: 5px;" v-on:click="downloadAsExcel()">Download As Excel</a>
                                    <a class="button is-link is-small" style="margin-left: 5px;" v-on:click="displayAttendance(1,3)">Attended 
                                        <font-awesome-icon icon="check-square" v-if="activeButton == 2" /></a>
                                    <a class="button is-primary is-small" style="margin-left: 5px;" v-on:click="displayAttendance(1,1)">On-Time 
                                        <font-awesome-icon icon="check-square" v-if="activeButton == 3" /></a>
                                    <a class="button is-warning is-small" style="margin-left: 5px;" v-on:click="displayAttendance(1,2)">Late 
                                        <font-awesome-icon icon="check-square" v-if="activeButton == 4" /></a>
                                    <a class="button is-danger is-small" style="margin-left: 5px;" v-on:click="displayAttendance(2,1)">Absent 
                                        <font-awesome-icon icon="check-square" v-if="activeButton == 5" /></a>
                                </div>
                            </div>
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns bottom-border">
                                        <div class="column">Name</div>
                                        <div class="column" v-if="viewStudentAttendance == 1">Status</div>
                                        <!-- <div class="column" v-if="viewStudentAttendance == 1">Check-in Time</div> -->
                                    </div>

                                    <div v-if="viewStudentAttendance == 1">
                                        <div class="columns" v-for="attendance in attendanceList" :key="attendance._id">
                                            <div class="column">{{ attendance.studentID.firstName }} {{ attendance.studentID.lastName }}</div>
                                            <div class="column">{{ displayStatus(attendance.status) }}</div>
                                            <!-- <div class="column">{{ attendance.checkInTime }}</div> -->
                                        </div>
                                    </div>

                                    <div v-if="viewStudentAttendance == 2">
                                        <div class="columns" v-for="attendance in attendanceList" :key="attendance._id">
                                            <div class="column">{{ attendance.firstName }} {{ attendance.lastName }}</div>
                                        </div>
                                    </div>

                                    <div v-if="viewStudentAttendance == 3">
                                        <div class="columns" v-for="attendance in attendanceList" :key="attendance._id">
                                            <div class="column">{{ attendance.firstName }} {{ attendance.lastName }}</div>
                                            <div class="column">{{ displayAttendanceStatus(attendance.checkIn, attendance.checkInStatus) }}</div>
                                            <!-- <div class="column">{{ attendance.checkInTime }}</div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </section>    
</div>
</template>

<script>
import TopMenu from '../TopMenu'
import axios from 'axios'
import "../public/style.scss";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';

export default {
    name: "StudentAttendance",
    components: {
        TopMenu,
        Loading,
        Datepicker
    },
    data() {
        return {
            groupID: '',
            groupName: '',
            viewStudentAttendance: 2, //1 - came, 2 - absent
            viewStudentAttendanceStatus: 1, //1 - on-time, 2 - late
            viewStudentAttendanceDisplay: '',
            actionDate: '',
            attendanceList: [],
            todayDateDisplay: '',
            isLoading1: false,
            selectedDate: '',
            todayDay : 0,
            todayMonth : 0,
            todayYear : 0,
            activeButton: 1,
            setDisplay: 0
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    computed:{     
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.duration = currentMonth;
        this.displayMonth = this.displayMonthName(currentMonth)
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = currentDate.getFullYear() + "" + currentMonth + "" + currentDay;
        this.actionYear = currentDate.getFullYear()

        this.todayDateDisplay = currentDay + " " + this.displayMonth + " " + this.actionYear

        this.groupID = this.$store.getters.getViewGroupID;
        if (this.groupID.length < 1){
            this.groupID = localStorage.getItem('VIEW_GROUP_ID')
        }

        this.groupName = this.$store.getters.getViewGroupName;
        if (this.groupName.length < 1){
            this.kelasName = localStorage.getItem('VIEW_GROUP_NAME')
        }

        console.log("groupID: " + this.groupID)
        console.log("groupName: " + this.groupName)

        this.viewStudentAttendanceStatus = this.$store.getters.getViewStudentAttendanceStatus;
        if (this.viewStudentAttendanceStatus < 1){
            this.viewStudentAttendanceStatus = localStorage.getItem('VIEW_STUDENT_ATTENDANCE_STATUS')
        
        }
        this.viewStudentAttendance = this.$store.getters.getViewStudentAttendance;
        if (this.viewStudentAttendance < 1){
            this.viewStudentAttendance = localStorage.getItem('VIEW_STUDENT_ATTENDANCE')
        }

        this.todayDay = currentDate.getDate()
        this.todayMonth = currentDate.getMonth()
        this.todayYear = currentDate.getFullYear()

        console.log("viewStudentAttendance: " + this.viewStudentAttendance);

    },
    mounted(){        
        this.$root.$emit('activeSideMenu',"ClassDashboardSingle")
        this.getAttendance(this.viewStudentAttendance,this.viewStudentAttendanceStatus,this.actionDate,0)
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        downloadAsExcel(){
            let self = this;
            console.log("downloadAsExcel with display: " + self.setDisplay + " and actionDate: " + self.actionDate)
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/api/group/attendance/details', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        display: self.setDisplay,
                        view: 'kelas',
                        groupID: self.groupID,
                        actionDate: self.actionDate,
                        status: self.viewStudentAttendanceStatus,
                        output: 'excel',
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', self.actionDate + '_students_attendance.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.errors.push(e)
                    console.log(e)
                })
        },
        displayAttendance(display,status){
            this.viewStudentAttendanceStatus = status;
            this.viewStudentAttendance = display;
            this.getAttendance(display,status,this.actionDate,0);
        },
        getAttendance(display,status,actionDate,caller){
            this.setDisplay = display;
            this.actionDate = actionDate;
            this.viewStudentAttendanceStatus = status;
            console.log("entering getattendance with: " + display + ", " + status)
            if ((display == 3) && (status== 3)){
                this.activeButton = 1;
            }
            if ((display == 1) && (status== 3)){
                this.activeButton = 2;
            }
            if ((display == 1) && (status== 1)){
                this.activeButton = 3;
            }
            if ((display == 1) && (status== 2)){
                this.activeButton = 4;
            }
            if ((display == 2) && (status== 1)){
                this.activeButton = 5;
            }

            if (caller == 1){   //called by datepicker
                var setActionDate = "";
                var setMonth = actionDate.getMonth() + 1;
                var setDay = actionDate.getDate();
                if (setMonth < 10){
                    setMonth = "0" + setMonth
                }
                if (setDay < 10){
                    setDay = "0" + setDay
                }
                this.todayDateDisplay = setDay + " " + this.displayMonthName(actionDate.getMonth() + 1) + " " + actionDate.getFullYear()
                setActionDate = actionDate.getFullYear() + setMonth + setDay
                actionDate = setActionDate
            }else{
                //this.selectedDate = this.actionDate
                console.log("year: " + this.todayYear + " day: " + this.todayDay + " mo: " + this.todayMonth)
                this.selectedDate = new Date(this.todayYear, this.todayMonth,this.todayDay )
            }
            this.actionDate = actionDate;
            let self = this;
            self.isLoading1 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')            
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/group/attendance/details', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        display: display,
                        groupID: this.groupID,
                        actionDate: actionDate,
                        status: status

                    }
                })
                .then(response => {
                    self.attendanceList = response.data
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log("273 Error:" + e)
                }) 
                    
            
        },
        goGroupDashboardSingle(){
            this.$store.commit('UPDATE_VIEW_GROUP_ID',this.groupID)
            this.$store.commit('UPDATE_VIEW_GROUP_NAME',this.groupName)
            localStorage.setItem('VIEW_GROUP_ID',this.groupID)
            localStorage.setItem('VIEW_GROUP_NAME',this.groupName)

            this.$router.push({
                name: "GroupDashboardSingle"
            });
        },
        goDashboard(){
            this.$router.push({
                name: "GroupDashboard"
            });
        },  
        displayMonthName(month){
            var monthDisplay = "";
            switch (month){
                case 1:
                    monthDisplay = "January";
                    break;
                case 2:
                    monthDisplay = "February";
                    break;
                case 3:
                    monthDisplay = "March";
                    break;
                case 4:
                    monthDisplay = "April";
                    break;
                case 5:
                    monthDisplay = "May";
                    break;
                case 6:
                    monthDisplay = "June";
                    break;
                case 7:
                    monthDisplay = "July";
                    break;
                case 8:
                    monthDisplay = "August";
                    break;
                case 9:
                    monthDisplay = "September";
                    break;
                case 10:
                    monthDisplay = "October";
                    break;
                case 11:
                    monthDisplay = "November";
                    break;
                case 12:
                    monthDisplay = "December";
                    break;
                default:
                    monthDisplay = "January";
                    break;
            }
            return monthDisplay;
        },
        displayStatus(status){
            if (status == 2){
                return "Late"
            }else{
                return "On-Time"
            }
        },
        displayAttendanceStatus(checkIn,checkInStatus){
            if (checkIn){
                var status = "";
                if (checkInStatus == 1){
                    status = ", On-time"
                }else{
                    status = ", Late"
                }
                return "Attended" + status
            }else{
                return "Absent"
            }
        }
    }
};
</script>

<style scoped>
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    margin-left: 10px;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.header-button{
    margin-top: 10px;
    margin-left: 10px;
}
.top-border{
    border-top: 1px solid #CCC
}
.right-border{
    border-right: 1px solid #CCC
}
.bottom-border{
    border-bottom: 1px solid #CCC
}
.text-center{
    text-align: center;
}
.header-input{
    margin: 10px;
}
.breadcrumb{
    padding: 10px;
}
.datepicker{
    margin-left: 30px;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/Group/StudentAttendance.vue